module.exports = __webpack_public_path__ + "img/c28.c2337ae1.png";